import { APP_ENV } from './env'

export const APP_TITLE = 'MOBIWAY™'
export const APP_SUBTITLE = () => (String(APP_ENV) !== 'prd' ? APP_ENV : '')
export const COOKIE_NAME = 'mobiway-token'

export const DIALOGS_WIDTH = 740

export const CABLE_VISIT_EVENT = 'CableVisit'

export const RESEND_TIME: number = 60
